<script>

  let {
        class: classInput,
        ref   = $bindable(null),
        children,
        sType = "neutral", // neutral, good, bad, info
        id = undefined,
        ...restProps
      } = $props();

</script>

<div class="notification1 {sType}" {id}>
  <div class="notification2">
    <div class="notification3">
      <div class="notification4">
        <div class="notification5">
          <p>
            {@render children?.()}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


<style>
  .notification1 {
    position: relative;
    width: 100%;
    margin-top: calc(15.29px + 1.1936vw);
    margin-bottom: calc(15.29px + 1.1936vw);

    @media (min-width: 48em) {
      margin-top: 0px;
    }
  }

  .notification2 {
    opacity: 1;
    height: auto;
  }

  .notification3 {
    scroll-margin-top: 50px;
  }

  .notification4 {
    position: relative;
    padding-left: calc(7.6448px + 0.5968vw);
  }

  .notification5 p {
    /*font-size: calc(6.6892px + 0.5222vw);*/
    font-size: calc(12px + 0.5222vw);
    font-weight: var(--font-weight-normal, 400);
    white-space: pre-line;
    transition: color 500ms;
    color: inherit;
    font-style: initial;
    text-transform: inherit;
    text-align: inherit;
    text-decoration: inherit;
    opacity: 1;

    @media (min-width: 48em) {
      font-size: calc(13px + 0.5222vw);
    }
  }

  .notification5 p::after {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 2px;
    background: rgb(218, 75, 75);
  }


  .notification1.neutral .notification5 p::after {
    background: var(--hmk-clr-theme-primary);
  }

  .notification1.good .notification5 p::after {
    background: forestgreen;
  }

  .notification1.info {
    background-color: rgba(166, 218, 248, 0.25);
    border-radius: 4px;
    padding: 12px 12px 12px 0;
  }

  .notification1.info .notification5 p::after {
    background: var(--hmk-clr-theme-primary);
  }

</style>

